export default __webpack_public_path__ + "static/media/colorpal-large.34a0477d.jpg";